import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#ff8f3c', // Softer orange
      light: '#ffa664', // Lighter orange
      dark: '#e67e35', // Darker orange for contrast
    },
    secondary: {
      main: '#2d1f23', // Softer dark color
      light: '#3d2b30',
    },
    text: {
      primary: '#4a4a4f',
      secondary: '#6f7376',
    },
    background: {
      default: '#fafafa',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'Poppins, sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '4rem',
      lineHeight: 1.2,
      letterSpacing: '-0.01562em',
      '@media (max-width:600px)': {
        fontSize: '3rem',
      },
    },
    h2: {
      fontWeight: 600,
      fontSize: '3rem',
      lineHeight: 1.3,
      '@media (max-width:600px)': {
        fontSize: '2.5rem',
      },
    },
    h3: {
      fontWeight: 600,
      fontSize: '2.5rem',
      lineHeight: 1.3,
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          padding: '12px 28px',
          fontSize: '1.1rem',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          userSelect: 'text',
        },
      },
    },
    MuiBox: {
      styleOverrides: {
        root: {
          userSelect: 'text',
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          userSelect: 'text',
          '@media (min-width: 1200px)': {
            maxWidth: 1280,
          },
        },
      },
    },
  },
});

export default theme;
